import { render, staticRenderFns } from "./PartnerAccounts.vue?vue&type=template&id=7ec676c2&"
import script from "./PartnerAccounts.vue?vue&type=script&lang=js&"
export * from "./PartnerAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports